import { render } from "./unhappyModal.vue?vue&type=template&id=483b5ecc&scoped=true&lang=html"
import script from "./unhappyModal.vue?vue&type=script&lang=js"
export * from "./unhappyModal.vue?vue&type=script&lang=js"

import "./unhappyModal.vue?vue&type=style&index=0&id=483b5ecc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483b5ecc"]])

export default __exports__